import { EnvironmentName } from "../enums/environment-name.enum";
import { Practice } from "../models/Practice";
import { User } from "../models/User";

export function shouldShowIntercom(environment: EnvironmentName, practice: Practice | null, user: User | null): boolean {
  const excludedProductionEuPractices: string[] = [
    '361', // V4P Selby
    '382', // V4P Gateshead
    '383', // V4P Newcastle Kingston Park
    '393', // V4P Huddersfield
    '394', // V4P Runcorn
  ];
  const excludedAuPractices: string[] = [
  ];
  const excludedStagingPractices: string[] = ['19', '20', '21', '22'];

  // If the user or practice is null, we cannot show Intercom
  if (!user || !practice) {
    return false;
  }

  // Do not show for PAH
  if ([EnvironmentName.V4P_PRODUCTION, EnvironmentName.V4P_STAGING, EnvironmentName.GROOMROOM_PRODUCTION, EnvironmentName.GROOMROOM_STAGING].includes(environment)) {
    return false;
  }

  if (environment === EnvironmentName.STAGING && excludedStagingPractices.includes(practice.id)) {
    // Special case for staging environment and practice with id '5'
    return false;
  }

  if (environment === EnvironmentName.PRODUCTION_LONDON && excludedProductionEuPractices.includes(practice.id)) {
    return false;
  }

  if (environment === EnvironmentName.PRODUCTION_SYDNEY && excludedAuPractices.includes(practice.id)) {
    return false;
  }

  return true;
}
